import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './Sidebar.css';

const Sidebar = ({ open = false, onNavigate }) => {
  const { user } = useSelector((state) => state.auth);

  const getMenuItems = () => {
    const baseItems = [
      { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/account', label: 'Account Info', icon: '👤' },
    ];

    const roleSpecificItems = {
      WHS: [
        { path: '/support', label: 'Support Inbox', icon: '🎧' },
        { path: '/documents', label: 'My Documents', icon: '📄' },
        { path: '/products', label: 'My Products', icon: '📦' },
        { path: '/rfqs', label: 'RFQs', icon: '📋' },
        { path: '/orders', label: 'Orders', icon: '🧾' },
        { path: '/analytics', label: 'Analytics', icon: '📈' },
      ],
      RTL: [
        { path: '/messages', label: 'My Messages', icon: '💬' },
        { path: '/browse', label: 'Browse/Discover', icon: '🔍' },
        { path: '/saved', label: 'Saved Products', icon: '❤️' },
        { path: '/rfqs', label: 'RFQs/Orders', icon: '📋' },
        { path: '/documents', label: 'Documents', icon: '📄' },
      ],
      ADMIN: [
        { path: '/support', label: 'Support Inbox', icon: '🎧' },
        { path: '/admin/users', label: 'User Management', icon: '👥' },
        { path: '/admin/products', label: 'Product Moderation', icon: '📦' },
        { path: '/admin/messages', label: 'Message Oversight', icon: '👁️' },
        { path: '/admin/orders', label: 'Orders Dashboard', icon: '📊' },
        { path: '/admin/audit', label: 'Audit Logs', icon: '📜' },
      ],
    };

    return [...baseItems, ...(roleSpecificItems[user?.accountType] || [])];
  };

  const handleNav = () => { if (onNavigate) onNavigate(); };

  return (
    <nav className={open ? 'sidebar open' : 'sidebar'} aria-label="Primary navigation">
      <div className="sidebar-menu">
        {getMenuItems().map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            className={({ isActive }) =>
              isActive ? 'sidebar-item active' : 'sidebar-item'
            }
            end={item.path === '/'}
            onClick={handleNav}
          >
            <span className="sidebar-icon">{item.icon}</span>
            <span className="sidebar-label">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default Sidebar;